import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const SubscribedRoute = ({ children }) => {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg0">
        <div className="overline animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.has_access) return <Navigate to="/subscribe" replace />;
  return children;
};
